module.exports = __webpack_public_path__ + "static/img/1_3.1f987f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/1_3.jpg
// module id = ltfG
// module chunks = 0